import { useQueryClient } from "@tanstack/react-query";
import { getQueryKey } from "@trpc/react-query";
import { trpc } from "../trpc";

export function useUpdateInterfaceConfig() {
  const queryClient = useQueryClient();

  return trpc.interface.updateConfig.useMutation({
    onMutate({ id, ...updatedConfig }) {
      const interfaceConfigQueryKey = getQueryKey(trpc.interface.getConfig, {
        id,
      });

      queryClient.setQueriesData(
        { queryKey: interfaceConfigQueryKey },
        (cache) => {
          if (!cache) {
            return cache;
          }
          return {
            ...cache,
            ...updatedConfig.body,
          };
        },
      );
    },
  });
}
